module.exports = __webpack_public_path__ + "img/Schiller.280768f9.jpeg";